import axios from 'axios';
import * as colors from '../../constants/colors';
import { snakeCaseToHumanReadable } from '@/utils/string';

const COLORS = {
  name: colors.COLOR_DATA_VIS_1,
  address: colors.COLOR_DATA_VIS_3,
  bank_account_name: colors.COLOR_DATA_VIS_2,
  bank_account_number: colors.COLOR_DATA_VIS_4,
  bank_account_beginning_balance: colors.COLOR_DATA_VIS_5,
  bank_account_ending_balance: colors.COLOR_DATA_VIS_6,
  transaction_description: colors.COLOR_DATA_VIS_7,
  transaction_date: colors.COLOR_DATA_VIS_8,
  transaction_amount: colors.COLOR_DATA_VIS_9,
  document_date: colors.COLOR_DATA_VIS_10,
};

export default {
  state: {
    isLoading: false,
    documents: {},
  },
  actions: {
    getParsedDetailsHighlighterBoundingBoxes(
      context,
      { customerId, documentId },
    ) {
      return axios
        .get(
          `/api/v2/customers/${customerId}/documents/${documentId}/parsed-detail-highlighter`,
        )
        .then((response) => {
          context.commit('setParsedDetailsHighlighterDocument', {
            documentId,
            pages: response.data.results,
          });

          return response;
        });
    },
  },
  mutations: {
    setParsedDetailsHighlighterLoading(state, loading) {
      state.isLoading = loading;
    },
    setParsedDetailsHighlighterDocument(state, { documentId, pages }) {
      state.documents[documentId] = pages.map((page) => {
        return page.map((boundingBox) => {
          const label = snakeCaseToHumanReadable(boundingBox.parsed_type ?? '');
          return {
            color: COLORS[boundingBox.parsed_type],
            label,
            instance: {
              boundingBox,
              bounding_boxes: [boundingBox],
            },
          };
        });
      });
    },
  },
};
